import { api } from 'app/config/apiConfig';
import { PriceHistoryDocument } from '../model/types';
import { InvoiceFrequencyType } from 'entities/Invoice';

interface Params {
  boxId?: string;
  cachedBoxId?: string;
  insuranceId?: string;
  cachedInsuranceId?: string;
  rentType?: InvoiceFrequencyType;
}
export const getUnitPriceHistoryApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUnitPriceHistory: build.query<PriceHistoryDocument[], Params | void>({
      query: (params) => ({
        url: '/price-history',
        params: params ? { ...params } : undefined,
      }),
      providesTags: ['Price History'],
    }),
  }),
});

export const { useGetUnitPriceHistoryQuery } = getUnitPriceHistoryApi;
